import ReportingDelay from './reportingDelay.view';

export default ReportingDelay;
